import { FirestoreDataConverter, GeoPoint } from "firebase/firestore"
import { DeviceDocument } from "../index"

export default {
    toFirestore: (thing: DeviceDocument) => ({
        thingName: thing.name,
        thingTypeName: thing.type,
        group: thing.group,
        organisation: thing.organisation,
        modules: thing.modules,
        coordinates: thing.coordinates
            ? new GeoPoint(thing.coordinates.latitude, thing.coordinates.longitude)
            : undefined,
    }),
    fromFirestore: (snapshot, options) => {
        const thing = snapshot.data(options)
        return {
            id: snapshot.id,
            name: thing.thingName,
            type: thing.thingTypeName,
            group: thing.group,
            organisation: thing.organisation,
            modules: thing.modules,
            coordinates: thing.coordinates?.toJSON(),
        }
    },
} as FirestoreDataConverter<Omit<DeviceDocument, "health">>
